module.exports = __webpack_public_path__ + "img/interface_altar_open.6a989b7d.png";